import { render } from "./Modal.vue?vue&type=template&id=68742133&bindings={}"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script